export const buildFlightExplorerUrl = (trackId: string, withReplay: boolean = false) => {
  const queryParameter = withReplay ? '?3dfr' : '';
  return `history/${trackId}/flight-explorer${queryParameter}`;
};
